module.exports = __webpack_public_path__ + "img/family-7.67e56176.jpg";